<template>
  <el-container>
    <el-aside width="220px">
      <el-container>
        <el-header height="51px"> LDAP目录浏览 </el-header>
        <el-main v-if="ready">
          <el-tree
            lazy
            ref="tree"
            node-key="dn"
            empty-text=""
            :default-expanded-keys="[options.ldap.root]"
            :expand-on-click-node="false"
            :props="treeProps"
            :load="loadNode"
            @node-click="handleNodeClick"
          >
          </el-tree>
        </el-main>
      </el-container>
    </el-aside>
    <el-main class="entry-list">
      <general-layout>
        <template #header>
          <east-operate>
            <template #left>
              <el-button
                type="primary"
                @click="handleSync()"
                v-if="btnRefreshCacheVisable || readOnlyMode"
              >
                同步
              </el-button>
              <el-dropdown
                @command="handleAdd"
                placement="bottom-start"
                v-if="!btnRefreshCacheVisable && !readOnlyMode"
              >
                <el-button type="primary"> 添加 </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="schema in editableSchemas"
                    :key="schema.name"
                    :command="schema.name"
                  >
                    {{ schema.title }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button @click="handleEdit(currentDn)"> 设置 </el-button>
              <!-- <el-button
                @click="handleMove(multipleSelection)"
                v-if="!btnRefreshCacheVisable"
              >
                移动
              </el-button>
              <el-button @click="handleDelete(multipleSelection)">
                删除
              </el-button> -->
              <el-button @click="handleWriteBack(multipleSelection)">
                邮箱账号创建
              </el-button>
              <el-button
                @click="handleSync()"
                v-if="!btnRefreshCacheVisable && !readOnlyMode"
              >
                同步
              </el-button>
              <el-button @click="refreshCache()" v-if="btnRefreshCacheVisable">
                清除缓存数据
              </el-button>
              <el-button @click="handleAlone()"> 查看独立节点 </el-button>
            </template>
            <template #right>
              <el-input
                placeholder="请输入关键字"
                v-model="inputKeyword"
                @keyup.enter.native="fetchData(currentDn, inputKeyword)"
                clearable
              >
                <el-button
                  icon="el-icon-search"
                  title="搜索"
                  @click="fetchData(currentDn, inputKeyword)"
                  slot="append"
                ></el-button>
              </el-input>
            </template>
          </east-operate>
        </template>
        <el-table
          :data="currentPages"
          row-key="dn"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            :selectable="selectableFunc"
            type="selection"
            prop="dn"
            width="46"
            :reserve-selection="true"
          >
          </el-table-column>
          <el-table-column min-width="120" align="left" label="名称">
            <template slot-scope="scope">
              <el-link
                v-if="scope.row.schema.isContainer"
                @click="handleExpand(scope.row)"
              >
                {{ scope.row.name }}
              </el-link>
              <el-link
                v-else-if="scope.row.schema.editable"
                @click="handleEdit(scope.row.dn)"
              >
                {{ scope.row.name }}
              </el-link>
              <span v-else>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column width="120" align="center" label="类型">
            <template slot-scope="scope">
              {{ scope.row.schema.title }}
            </template>
          </el-table-column>
          <layui-table-column
            prop="realName"
            min-width="90"
            align="left"
            label="实际名称"
          ></layui-table-column>
          <el-table-column
            prop="displayName"
            min-width="100"
            align="left"
            label="显示名称"
          ></el-table-column>

          <el-table-column
            prop="mail"
            min-width="180"
            align="left"
            label="邮箱"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            min-width="200"
            align="left"
            label="描述"
          ></el-table-column>
          <!-- <el-table-column width="200" align="left" label="描述">
            <template slot-scope="scope">
              {{ scope.row.description }}
            </template>
          </el-table-column> -->
          <el-table-column prop="state" width="80" align="center" label="状态">
            <template slot-scope="scope">
              <span v-if="'boolean' === typeof scope.row.state">
                <span v-if="scope.row.state" class="text-success">启用</span>
                <span v-else class="text-danger">禁用</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sync"
            width="80"
            align="center"
            label="同步状态"
          >
            <template slot-scope="scope">
              <span v-if="'boolean' === typeof sync[scope.row.dn]">
                <span v-if="sync[scope.row.dn]" class="text-success">成功</span>
                <span v-else class="text-danger">失败</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="operate"
            width="100"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="handleMove([scope.row])"
                v-if="!btnRefreshCacheVisable && !readOnlyMode"
                v
              >
                移动
              </el-button>
              <el-button
                type="text"
                @click="handleDelete([scope.row])"
                v-if="!btnRefreshCacheVisablec && !readOnlyMode"
              >
                删除
              </el-button>
              <el-button
                type="text"
                @click="handleEdit(scope.row.dn)"
                v-if="btnRefreshCacheVisable || readOnlyMode"
              >
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <template #footer>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="$page.sizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </template>
      </general-layout>
    </el-main>
    <el-dialog
      title="独立同步节点"
      :visible.sync="aloneVisible"
      class="dialog-alone"
      width="800px"
    >
      <entry-alone
        v-if="aloneVisible"
        ref="aloneModal"
        :dn="currentDn"
        @select="handleSelect"
      ></entry-alone>
    </el-dialog>
    <el-dialog title="节点属性设置" :visible.sync="editorVisible" width="900px">
      <entry-editor
        v-if="editorVisible"
        :dn="editDn"
        :is-add="isAdd"
        :schema-name="editSchemaName"
        @complete="
          editorVisible = false;
          aloneFresh();
        "
      ></entry-editor>
    </el-dialog>
    <el-dialog title="选择移动目标" :visible.sync="moveVisible" width="800px">
      <el-form>
        <el-form-item>
          <el-input
            style="width: 280px"
            placeholder="输入关键字搜索部门"
            v-model="unitKeyword"
          />&nbsp;&nbsp;
          <el-button @click="handleUnitSearch">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-select style="width: 100%" v-model="position">
            <el-option
              v-for="unit in unitList"
              :key="unit"
              :value="unit"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doMove">移动到所选部门</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
import LDAP from "@/api/sync/ldap";
import LDAPEXTEND from "@/api/sync/mailcreate";
import { mapState } from "vuex";
import TASK from "@/api/sync/task";
import EntryAlone from "@/pages/ldap/entry-alone";
import EntryEditor from "@/pages/ldap/entry-editor";
import { escapeSplit, escapeName, fromHex, toHex } from "@/utils/tools";

export default {
  breadcrumbData() {
    const navs = [];
    const root = this.options?.ldap?.root;
    const current = this.currentDn;
    if (root && current) {
      let getRoot = false;
      escapeSplit(current, ",")
        .reverse()
        .reduce((prev, val) => {
          let current = prev ? val + "," + prev : val;
          if (!getRoot && current.toLowerCase() === root.toLowerCase()) {
            getRoot = true;
          }
          if (getRoot) {
            navs.push({
              title: escapeName(escapeSplit(val, "=")[1]),
              path: this.$route.path,
              query: { h: toHex(current), k: this.currentKeyword }
            });
          }
          return current;
        }, "");
    }
    return navs;
  },
  components: { EntryEditor, EntryAlone },
  props: {
    hex: String,
    keyword: { type: String, default: "" }
  },
  data() {
    return {
      page: { entries: [], guid: null, isCompleted: false },
      sync: {},
      treeProps: {
        children: "children",
        label: "name",
        isLeaf: "leaf"
      },
      currentDn: null,
      currentPage: 1,
      pageSize: this.$page.size,
      currentKeyword: "",
      inputKeyword: "",
      multipleSelection: [],
      aloneVisible: false,
      editorVisible: false,
      isAdd: false,
      editDn: "",
      editSchemaName: "",
      moveVisible: false,
      moveEntries: [],
      unitKeyword: "",
      position: "",
      unitList: [],
      syncLoading: false,
      pathLoadCompleted: false,
      btnRefreshCacheVisable: false,
      readOnlyMode: false
    };
  },
  async created() {
    this.inputKeyword = this.routeKeyword;
    // 等待Store初始化完成
    await this.$store.init;
    this.readOnlyMode = this.$store.state.options.ldap.readOnlyMode;
    // console.log(this.$store.state.options.ldap.readOnlyMode);
    var manager = this.$store.state.options.ldap.manager;
    this.btnRefreshCacheVisable =
      manager == "DingDingManager" ||
      manager == "FsManager" ||
      manager == "WorkWeiXinManager" ||
      manager == "CebenvironmentManager" ||
      manager.includes("CE_") ||
      manager.includes("FsManager") ||
      manager.includes("DingDingManager") ||
      manager.includes("WorkWeiXin");
    await this.fetchData(this.routeDn, this.routeKeyword);
  },
  computed: {
    ...mapState(["ready", "options", "schemas"]),
    routeDn: vm => (vm.hex ? fromHex(vm.hex) : vm.options?.ldap?.root),
    routeKeyword: vm => vm.keyword ?? "",
    total: vm => vm.page.entries.length,
    editableSchemas: vm => vm.schemas?.filter(s => s.editable) ?? [],
    currentPages: vm =>
      vm.page.entries.slice(
        (vm.currentPage - 1) * vm.pageSize,
        vm.currentPage * vm.pageSize
      )
  },
  watch: {
    currentPages: "getSync",
    routeDn() {
      this.fetchData(this.routeDn, this.routeKeyword);
    },
    routeKeyword() {
      this.fetchData(this.routeDn, this.routeKeyword);
    }
  },
  methods: {
    selectableFunc(row) {
      //console.log(index);
      if (row.schema.name === "user") {
        return true;
      } else {
        return false;
      }
    },
    async fetchData(dn, keyword, force) {
      if (this.routeDn !== dn || this.routeKeyword !== keyword) {
        this.currentDn = this.routeDn;
        this.currentKeyword = this.routeKeyword;
        this.$router.push({ query: { h: toHex(dn), k: keyword } });
      } else if (
        this.currentDn !== dn ||
        this.currentKeyword !== keyword ||
        force
      ) {
        this.currentDn = dn;
        this.currentKeyword = keyword;
        this.currentPage = 1;
        let response = await LDAP.ENTRY_LIST({ dn, keyword });
        this.page = Object.freeze(response.data.page);
        this.sync = Object.freeze(response.data.sync);
        this.getPage(this.page.guid);
      }
    },
    async loadNode(node, resolve) {
      let response = await LDAP.CONTAINER_LIST({ dn: node.data?.dn });
      let data = response.data.map(entry => ({ ...entry, leaf: false }));
      this.pathLoad(data);
      resolve(data);
    },
    pathLoad(data) {
      if (!this.pathLoadCompleted) {
        let pathEntry = data.find(entry => this.currentDn.endsWith(entry.dn));
        if (pathEntry) {
          this.$nextTick(() => {
            this.$refs.tree.getNode(pathEntry.dn)?.expand();
          });
        } else {
          this.pathLoadCompleted = true;
        }
      }
    },
    async reloadNode(dn) {
      let node = this.$refs.tree.getNode(dn);
      if (node) {
        node.loaded = false;
        node.loadData();
        node.expand();
      }
    },
    async refreshCache() {
      let response = await LDAP.DELETE_CACHE();
      if (response.status == 200) {
        this.$message.success("更新缓存数据成功");
        this.$router.push({ path: "/ldap" });
        let response2 = await LDAP.ENTRY_LIST({
          dn: this.$store.state.options.ldap.root,
          keyword: ""
        });
        this.page = Object.freeze(response2.data.page);
        this.sync = Object.freeze(response2.data.sync);
        this.getPage(this.page.guid);
        this.reloadNode(this.$store.state.options.ldap.root);
      } else {
        this.$message.error("清除缓存数据异常");
      }
    },
    async getPage(guid) {
      if (!this.page.isCompleted) {
        let response = await LDAP.GET_PAGE({ guid });
        if (response.data.state) {
          if (this.page.guid === guid) {
            this.page = Object.freeze({
              ...this.page,
              isCompleted: response.data.isCompleted,
              entries: [
                ...this.page.entries,
                ...response.data.entries.map(e => Object.freeze(e))
              ]
            });
            this.getPage(guid);
          }
        }
      }
    },
    async getSync() {
      let completed = false;
      if (!this.syncLoading) {
        this.syncLoading = true;
        try {
          let dns = this.currentPages
            .map(entry => entry.dn)
            .filter(dn => this.sync[dn] === undefined)
            .slice(0, 100);

          // 判断是否加载完成
          if (!dns.length) {
            completed = true;
            return;
          }

          // 加载同步状态
          let placeSync = {};
          for (let dn of dns) {
            placeSync[dn] = -1;
          }
          let response = await LDAP.GET_SYNC({ entries: dns });
          if (response.data.state) {
            this.sync = Object.freeze({
              ...this.sync,
              ...placeSync,
              ...response.data.sync
            });
          }
        } finally {
          this.syncLoading = false;
          if (!completed) {
            this.getSync();
          }
        }
      }
    },
    handleNodeClick(data, node) {
      this.fetchData(data.dn, this.keyword);
      if (!node.loaded) {
        node.expand();
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleExpand(entry) {
      this.fetchData(entry.dn, this.keyword);
      this.$refs.tree.getNode(entry.dn)?.expand();
    },
    handleAdd(command) {
      this.isAdd = true;
      this.editDn = this.currentDn;
      this.editorVisible = true;
      this.editSchemaName = command;
    },
    handleEdit(dn) {
      this.isAdd = false;
      this.editDn = dn;
      this.editorVisible = true;
    },
    /* async handleSync() {
      let response = await TASK.CREATE({ dn: this.currentDn });
      if (response.data.state) {
        this.$message.success("同步任务创建成功");
      } else {
        this.$message.error(response.data.message ?? "同步任务创建失败");
      }
    },*/
    async handleSync() {
      try {
        await this.$confirm(
          //"确定同步当前[" + this.currentDn + "]结点,确认?",
          "确定为[" +
            this.$store.state.options.ldap.root +
            "]创建同步任务, 确认?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            lockScroll: false
          }
        );
        let response = await TASK.CREATE({
          dn: this.$store.state.options.ldap.root
        });
        //  let response = await TASK.CREATE({ dn: this.currentDn });
        if (response.data.state) {
          this.$message.success("同步任务创建成功");
        } else {
          this.$message.error(response.data.message ?? "同步任务创建失败");
        }
        // eslint-disable-next-line no-empty
      } catch {
        return;
      }
    },
    async handleDelete(entries) {
      // 删除提示
      try {
        await this.$confirm("确定删选中LDAP结点?", "删除确认", {
          type: "info"
        });
        this.fetchData(this.currentDn, this.keyword, true);
      } catch {
        return;
      }

      // 执行删除
      let response = await LDAP.ENTRY_REMOVE({
        dns: entries.map(e => e.dn)
      });
      if (response.data.state) {
        this.$message.success("删除成功");
      } else {
        this.$message.error(response.data.message);
      }
    },
    async handleWriteBack(entries) {
      if (this.multipleSelection.length === 0) {
        this.$message.info("请选择要单独创建邮箱的账号!");
        return;
      }
      // 删除提示
      try {
        await this.$confirm("确定为选定的账号创建邮箱至默认部门?", "回写确认", {
          type: "info"
        });
        this.fetchData(this.currentDn, this.keyword, true);
      } catch {
        return;
      }

      // 执行删除(20230418新增)
      let response = await LDAPEXTEND.ENTRY_WRITEBACK({
        dns: entries.map(e => e.dn)
      });
      this.$message.success(
        "选定账号同步任务创建成功, 请稍后刷新页面查看, 或在任务记录中查看详细信息"
      );
      if (response.data.state) {
        //页面刷新
        this.reloadNode(this.$store.state.options.ldap.root);
        //this.$message.success("邮箱信息回写成功");
      } else {
        this.$message.error(response.data.message);
      }
    },
    handleAlone() {
      this.aloneVisible = true;
    },
    async aloneFresh() {
      this.$refs.aloneModal.fetchData();
    },
    handleMove(entries) {
      if (!entries.length) {
        this.$message.info("请选择要移动的节点");
        return;
      }
      this.moveEntries = entries.map(e => e.dn);
      this.moveVisible = true;
    },
    handleSelect(entry) {
      this.handleEdit(entry.dn);
    },
    async handleUnitSearch() {
      let response = await LDAP.UNIT_SEARCH({ keyword: this.unitKeyword });
      if (response.data.state) {
        this.unitList = response.data.unitList;
        if (!this.position && this.unitList.length) {
          this.position = this.unitList[0];
        }
      }
    },
    async doMove() {
      let response = await LDAP.ENTRY_MOVE({
        dns: this.moveEntries,
        position: this.position
      });
      if (response.data.state) {
        this.$message.success("移动成功");
        this.reloadNode(this.position);
        this.reloadNode(this.currentDn);
        this.fetchData(this.currentDn, this.currentKeyword, true);
        this.moveVisible = false;
      } else {
        this.$message.error(response.data.message);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.el-button + .el-dropdown,
.el-dropdown + .el-button {
  margin-left: 10px;
}
.el-aside {
  border-right: 1px solid #eee;
  display: flex;
  flex-direction: column;
  .el-container {
    min-height: 0;
    flex: auto;
    .el-header {
      font-size: 17px;
      font-weight: bold;
      text-align: center;
      padding-top: 15px;
    }
    .el-main {
      min-height: 0;
      padding: 0;
      overflow: auto;

      .el-tree {
        margin: 0 10px;
        display: inline-block;
        ::v-deep > .el-tree-node {
          min-width: 100%;
          display: inline-block;
        }
      }
    }
  }
}
.entry-list {
  padding: 0;
  display: flex;
}
.dialog-alone::v-deep .el-dialog__body {
  padding: 0 20px 10px;
}
</style>
